"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  EidBase: 'serp.components.',
  ClickSearchBox: 'search_box.textarea.click',
  SuggestedDomainsDropDown: 'drop_down.suggestion.click',
  SearchButton: 'search_bar.search.click',
  SearchHistoryDropdown: 'drop_down.search_history.click',
  VoiceSearch: 'search_bar.voice_search.click',
  VoiceSearchError: 'search_bar.voice_search.click.error',
  SpeechRecognitionApiError: 'search_bar.speechRecognitionApi.click.error',
  promptRecommendation: 'prompt_recommendation.impression',
  promptRecommendationShown: 'prompt_recommendation.shown.impression',
  promptButton: 'prompt_recommendation.click',
  promptAddToCart: 'prompt_recommendation.add_to_cart.click',
  promptSuggestionsShown: 'prompt_recommendation.suggestions.impression',
  promptSuggestionsClose: 'prompt_recommendation.suggestions_close.click',
  promptSuggestionsBack: 'prompt_recommendation.suggestions_back.click',
  promptAddToCartError: 'prompt_recommendation.add_to_cart_error.impression',
  promptAddToCartSuccess: 'prompt_recommendation.add_to_cart_success.impression',
  promptDomainPurchaseSuccess: 'prompt_recommendation.domain_purchase_success.impression',
  promptDomainPurchaseFailure: 'prompt_recommendation.domain_purchase_failure.impression',
  promptDomainPurchaseClose: 'prompt_recommendation.domain_purchase_close.click',
  promptDomainPurchaseBack: 'prompt_recommendation.domain_purchase_back.click'
};